// 一个小的全局变量，用于存储一些和状态无关的数据
const __sharedData = {};

export const setSharedData = (name, value) => {
  __sharedData[name] = value;
};

export const getSharedData = (name, fallbackValue) => {
  return __sharedData[name] || fallbackValue;
};

export const sharedData = {
  set: setSharedData,
  get: getSharedData,
};

globalThis.__SHAKKER_SHARED_DATA__ = __sharedData;
